export default __webpack_public_path__ + "d7ccc63be34b79d90b3de883cc387eeb.svg";